var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { parseError } from "./expapiv2/ExpApiV2.utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const apiVersion = "2023-09-30-preview";
let NotificationSettingResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.default, "", parseError);
  }
  getNotificationSettingList(workspaceId, skip, top, searchStr) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/notification-subscriptions?notificationSubscriptionType=Admin&skip=${skip}&top=${top}&api-version=${apiVersion}`;
      const result = yield this._get(address);
      return result;
    });
  }
  putNotificationSetting(workspaceId, id, notificationSettingDetail) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/notification-subscriptions/${id}?api-version=${apiVersion}`;
      const result = yield this._put(notificationSettingDetail, address);
      return result;
    });
  }
  deleteNotificationSetting(workspaceId, notificationSubscriptionId) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/notification-subscriptions/${notificationSubscriptionId}?api-version=${apiVersion}`;
      const result = yield this._delete(address);
      return result;
    });
  }
};
NotificationSettingResource = __decorateClass([
  WPSProxyConverter()
], NotificationSettingResource);
const NotificationSettingResource$1 = new NotificationSettingResource();
export {
  NotificationSettingResource$1 as default
};
//# sourceMappingURL=NotificationSettingResource.js.map
